import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';

const FinalCTA = () => {
  return (
    <section className="py-20 px-6 bg-[#6B7A5C]">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
          When you spend less on what doesn't matter, you gain freedom for what does.
        </h2>
        
        <p className="text-[#D4E0CC] text-lg mb-10 max-w-2xl mx-auto">
          SpendLess isn't about sacrifice. It's about designing a life where your money goes further, your food is better, your home runs smarter, and you wake up with less financial weight on your shoulders.
        </p>
        
        <Link to="/products/guide">
          <Button 
            className="bg-white text-[#6B7A5C] hover:bg-[#F5F1E8] px-10 py-6 text-lg rounded-lg transition-all shadow-md hover:shadow-lg font-semibold relative"
          >
            <span className="absolute -top-3 -right-3 bg-[#C17855] text-white text-xs px-3 py-1 rounded-full font-bold">
              33% OFF
            </span>
            Get SpendLess — $9.99
          </Button>
        </Link>
        
        <p className="text-[#D4E0CC] text-sm mt-6">
          🚀 Launch special: First 100 buyers only
        </p>
      </div>
    </section>
  );
};

export default FinalCTA;